// Bootstrap JS
var bootstrap = require('bootstrap');

document.addEventListener('DOMContentLoaded', () => {

});
